import { userAxios } from '../index'

/**
 * Servicio para crear un nuevo miembro del agente
 * @param {Object} data - Datos del miembro a crear
 * @param {string} data.name - Nombre del miembro
 * @param {string} data.lastname - Apellido del miembro
 * @param {string} data.date_birth - Fecha de nacimiento (formato: MM-DD-YYYY)
 * @param {string} data.phone - Teléfono del miembro
 * @param {string} data.gender - Género (male/female)
 * @param {string} data.email - Email del miembro
 * @param {number} data.user_references_id - ID de la referencia
 * @param {number} data.agent_user_id - ID del agente usuario
 * @param {number} data.memberships_parameters_id - ID del parámetro de membresía
 * @param {number} data.cash - Cantidad en efectivo
 * @param {number} data.cc - Cantidad en tarjeta de crédito
 * @returns {Promise} Respuesta del API con el resultado de la creación
 */
const createAgentMember = async (data) => {
  try {
    const response = await userAxios.post('user-agent-member', data)
    return response.data
  } catch (error) {
    console.error('Error creating agent member:', error)
    throw error
  }
}

/**
 * Panel del agente de planes (rol agent plan). Todos aceptan start_date y end_date en m-d-Y,
 * per_page (1 a 100) y page. Sin fechas, el resumen, las citas y las solicitudes usan el mes en curso.
 * @param {Object} params
 * @returns {Promise<Object>} { status, message, data }
 */
const getDashboardSummary = (params = {}) =>
  userAxios.get('agent-plan/dashboard/summary', { params }).then((response) => response.data)

/** @param {Object} params - status: active | payment_failed | cancel_scheduled | canceled */
const getAffiliates = (params = {}) =>
  userAxios.get('agent-plan/dashboard/affiliates', { params }).then((response) => response.data)

const getAppointments = (params = {}) =>
  userAxios.get('agent-plan/dashboard/appointments', { params }).then((response) => response.data)

const getRequests = (params = {}) =>
  userAxios.get('agent-plan/dashboard/requests', { params }).then((response) => response.data)

const getCommissions = (params = {}) =>
  userAxios.get('agent-plan/dashboard/commissions', { params }).then((response) => response.data)

/**
 * Panel de la agencia (rol agent admin): totales, Élite, comisión propia y sus agentes paginados.
 * @param {Object} params
 * @returns {Promise<Object>} { status, message, data }
 */
const getAgencyDashboard = (params = {}) =>
  userAxios.get('agency-plan/dashboard', { params }).then((response) => response.data)

const getAgencyCommissions = (params = {}) =>
  userAxios.get('agency-plan/dashboard/commissions', { params }).then((response) => response.data)

export default {
  createAgentMember,
  getDashboardSummary,
  getAffiliates,
  getAppointments,
  getRequests,
  getCommissions,
  getAgencyDashboard,
  getAgencyCommissions,
}
